{
  "version": 1,
  "asset_id": "bf0ee299-c5c0-44ba-a821-5805114496e6",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/bf0ee299-c5c0-44ba-a821-5805114496e6/dilated-pouch-boxed-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/bf0ee299-c5c0-44ba-a821-5805114496e6/dilated-pouch-boxed-es-480.webp",
  "original_filename": "dilated-pouch-boxed-es-480.webp",
  "size": 19692,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:09:08Z"
}
